export const GET_PRODUCTS_PENDING = "GET_PRODUCTS_PENDING"
export const GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS"
export const GET_PRODUCTS_FAILURE = "GET_PRODUCTS_FAILURE"

export const GET_PRODUCTS_NAME_PENDING = "GET_PRODUCTS_NAME_PENDING"
export const GET_PRODUCTS_NAME_SUCCESS = "GET_PRODUCTS_NAME_SUCCESS"
export const GET_PRODUCTS_NAME_FAILURE = "GET_PRODUCTS_NAME_FAILURE"

export const ADD_PRODUCTS_PENDING = "ADD_PRODUCTS_PENDING"
export const ADD_PRODUCTS_SUCCESS = "ADD_PRODUCTS_SUCCESS"
export const ADD_PRODUCTS_FAILURE = "ADD_PRODUCTS_FAILURE"

export const UPLOAD_PRODUCTS_PENDING = "UPLOAD_PRODUCTS_PENDING"
export const UPLOAD_PRODUCTS_SUCCESS = "UPLOAD_PRODUCTS_SUCCESS"
export const UPLOAD_PRODUCTS_FAILURE = "UPLOAD_PRODUCTS_FAILURE"

export const EDIT_PRODUCTS_PENDING = "EDIT_PRODUCTS_PENDING"
export const EDIT_PRODUCTS_SUCCESS = "EDIT_PRODUCTS_SUCCESS"
export const EDIT_PRODUCTS_FAILURE = "EDIT_PRODUCTS_FAILURE"

export const DELETE_PRODUCTS_PENDING = "DELETE_PRODUCTS_PENDING"
export const DELETE_PRODUCTS_SUCCESS = "DELETE_PRODUCTS_SUCCESS"
export const DELETE_PRODUCTS_FAILURE = "DELETE_PRODUCTS_FAILURE"

export const DOWNLOAD_PRODUCTS_PENDING = "DOWNLOAD_PRODUCTS_PENDING"
export const DOWNLOAD_PRODUCTS_SUCCESS = "DOWNLOAD_PRODUCTS_SUCCESS"
export const DOWNLOAD_PRODUCTS_FAILURE = "DOWNLOAD_PRODUCTS_FAILURE"

export const DOWNLOAD_PRODUCTS_BY_ID_PENDING = "DOWNLOAD_PRODUCTS_BY_ID_PENDING"
export const DOWNLOAD_PRODUCTS_BY_ID_SUCCESS = "DOWNLOAD_PRODUCTS_BY_ID_SUCCESS"
export const DOWNLOAD_PRODUCTS_BY_ID_FAILURE = "DOWNLOAD_PRODUCTS_BY_ID_FAILURE"
